import * as _ from 'underscore';

import { IGlob } from '../Glob';
import { ColorBoxField } from '../../../../_common/platform/ts/ColorBoxField';
import { FontField } from '../../../../_common/platform/ts/FontField';
import BooleanField from '../../../../_common/platform/ts/BooleanField';
import SelectField from '../../../../_common/platform/ts/SelectField';
import NumberField from '../../../../_common/platform/ts/NumberField';
import * as appTheme from '../../../../_common/platform/ts/appTheme';
import { validators } from '../../../../_common/platform/ts/validators';
import * as Utilities from '../../../../_common/platform/ts/Utilities';

declare var Color: any;

const template = require('!!raw-loader!pdc-platform/src/appTheme.template.css').default;

import { BaseUIElementsPreview } from './previews/BaseUIElementsPreview';
import { CommonPreview } from './previews/CommonPreview';
import { NavBarPreview } from './previews/NavBarPreview';
import { themeVars } from './themeConstants';

export const BASE_FONTS_AND_COLORS_SECTION_ID = 'base-fonts-and-colors';
export const BASE_FONTS_AND_COLORS_SECTION_NAME = 'Base Fonts and Colors';

export const BASE_ELEMENTS_SECTION_ID = 'base-elements';
export const BASE_ELEMENTS_SECTION_NAME = 'Base Elements';

export const TREE_SECTION_ID = 'tree';
export const TREE_SECTION_NAME = 'Tree';
export const TREE_SELECTED_ITEM_GROUP_ID = 'tree-selected-item';

export const CONTEXT_MENU_SECTION_ID = 'context-menu';
export const CONTEXT_MENU_SECTION_NAME = 'Context Menu';

export const ITEM_SELECTOR_SECTION_ID = 'item-selector';
export const ITEM_SELECTOR_SECTION_NAME = 'Item Selector';

export const NAVIGATION_BAR_SECTION_NAME = 'Top Navigation Bar';
export const NAVIGATION_BAR_SECTION_ID = 'navbar';

export module BootstrapTheme {
    const _init = [];

    function getContrastColor(theme, field) {
        return Utilities.getContrastColor(theme[field]);
    }

    export function init(glob: IGlob) {
        if (_.indexOf(_init, glob) !== -1) {
            return;
        }

        appTheme.registerSections([
            {
                id: NAVIGATION_BAR_SECTION_ID,
                name: NAVIGATION_BAR_SECTION_NAME,
                preview: NavBarPreview,
                previewClassName: 'preview-nav-bar',
                visibility: ['application']
            },

            {
                id: BASE_FONTS_AND_COLORS_SECTION_ID,
                name: BASE_FONTS_AND_COLORS_SECTION_NAME,
                preview: CommonPreview,
                previewClassName: 'preview-common',
                themeType: 'Base'
            },

            {
                id: BASE_ELEMENTS_SECTION_ID,
                name: BASE_ELEMENTS_SECTION_NAME,
                preview: BaseUIElementsPreview,
                previewClassName: 'preview-base-UI-elements',
                themeType: 'Base UI Elements',
                visibility: ['application', 'workspace', 'widget']
            },
            // visibility: ['application','workspace','widget']
            // {
            //     id: 'table',
            //     name: 'Table',
            //     preview: BaseUIElementsPreview, //TablePreview,
            //     previewClassName: 'preview-base-UI-elements', //'preview-table',
            //     parent: BASE_ELEMENTS_SECTION_ID
            // },

            {
                id: 'btn',
                name: 'Buttons',
                preview: BaseUIElementsPreview, //ButtonDefaultPreview,
                previewClassName: 'preview-base-UI-elements', //'preview-button',
                parent: BASE_ELEMENTS_SECTION_ID
            },

            {
                id: 'link',
                name: 'Link',
                preview: BaseUIElementsPreview,
                previewClassName: 'preview-base-UI-elements',
                parent: BASE_ELEMENTS_SECTION_ID
            },

            {
                id: CONTEXT_MENU_SECTION_ID,
                name: CONTEXT_MENU_SECTION_NAME,
                preview: BaseUIElementsPreview, //DropdownPreview,
                previewClassName: 'preview-base-UI-elements', //'preview-dropdown',
                parent: BASE_ELEMENTS_SECTION_ID
            },

            {
                id: 'dateField',
                name: 'Date Input',
                preview: BaseUIElementsPreview, //DateFieldPreview,
                previewClassName: 'preview-base-UI-elements', //'preview-datefield',
                parent: BASE_ELEMENTS_SECTION_ID
            },

            {
                id: 'input',
                name: 'Input',
                preview: BaseUIElementsPreview, //InputPreview,
                previewClassName: 'preview-base-UI-elements', //'preview-input',
                parent: BASE_ELEMENTS_SECTION_ID
            },

            {
                id: ITEM_SELECTOR_SECTION_ID,
                name: ITEM_SELECTOR_SECTION_NAME,
                preview: BaseUIElementsPreview,
                previewClassName: 'preview-base-UI-elements',
                parent: BASE_ELEMENTS_SECTION_ID
            },

            {
                id: 'navtab',
                name: 'Nav Tabs and Pills',
                preview: BaseUIElementsPreview, //NavTabPreview,
                previewClassName: 'preview-base-UI-elements', //'preview-nav-tab',
                parent: BASE_ELEMENTS_SECTION_ID
            },

            {
                id: 'popover',
                name: 'Popover',
                preview: BaseUIElementsPreview, //PopoverPreview,
                previewClassName: 'preview-base-UI-elements', //'preview-popover',
                parent: BASE_ELEMENTS_SECTION_ID
            },

            {
                id: 'modal',
                name: 'Modal',
                preview: BaseUIElementsPreview, //ModalPreview,
                previewClassName: 'preview-base-UI-elements', //'preview-modal',
                parent: BASE_ELEMENTS_SECTION_ID
            },

            // {
            //     id: 'listgroup',
            //     name: 'List Group',
            //     preview: BaseUIElementsPreview, //ListGroupPreview,
            //     previewClassName: 'preview-base-UI-elements', //'preview-list-group',
            //     parent: BASE_ELEMENTS_SECTION_ID
            // },

            {
                id: 'panel',
                name: 'Panel',
                preview: BaseUIElementsPreview, //PanelPreview,
                previewClassName: 'preview-base-UI-elements', //'preview-panel',
                parent: BASE_ELEMENTS_SECTION_ID
            },

            {
                id: 'progress-bar',
                name: 'Progress Bar',
                preview: BaseUIElementsPreview, //ProgressPreview,
                previewClassName: 'preview-base-UI-elements', //'preview-progress-bar',
                parent: BASE_ELEMENTS_SECTION_ID
            },

            {
                id: 'breadcrumb',
                name: 'Breadcrumb',
                preview: BaseUIElementsPreview, //BreadcrumbPreview,
                previewClassName: 'preview-base-UI-elements', //'preview-breadcrumb',
                parent: BASE_ELEMENTS_SECTION_ID
            },

            {
                id: 'notifications',
                name: 'Notifications',
                preview: BaseUIElementsPreview, //NotificationsPreview,
                previewClassName: 'preview-base-UI-elements', //'preview-notifications',
                parent: BASE_ELEMENTS_SECTION_ID,
                visibility: ['application', 'workspace']
            },

            {
                id: 'scrollbar',
                name: 'Scroll Bar',
                preview: BaseUIElementsPreview,
                previewClassName: 'preview-base-UI-elements',
                parent: BASE_ELEMENTS_SECTION_ID
            },

            {
                id: TREE_SECTION_ID,
                name: TREE_SECTION_NAME,
                preview: BaseUIElementsPreview,
                previewClassName: 'preview-base-UI-elements',
                parent: BASE_ELEMENTS_SECTION_ID
            },

            {
                id: 'colorbox',
                name: 'Color Box',
                //preview: BaseUIElementsPreview,
                //previewClassName: 'preview-base-UI-elements',
                parent: BASE_ELEMENTS_SECTION_ID
            }
        ]);

        appTheme.registerGroups([
            {
                id: 'base-font',
                name: 'Main Font',
                section: BASE_FONTS_AND_COLORS_SECTION_ID
            },

            {
                id: 'base-background-colors',
                name: 'Background Colors',
                section: BASE_FONTS_AND_COLORS_SECTION_ID
            },

            {
                id: 'base-foreground-colors',
                name: 'Foreground Colors',
                section: BASE_FONTS_AND_COLORS_SECTION_ID
            },

            {
                id: 'brand-colors',
                name: 'Brand Colors',
                section: BASE_FONTS_AND_COLORS_SECTION_ID
            },

            {
                id: 'btn-default',
                name: 'Default',
                section: 'btn'
            },

            {
                id: 'btn-success',
                name: 'Success',
                section: 'btn'
            },

            {
                id: 'btn-info',
                name: 'Info',
                section: 'btn'
            },

            {
                id: 'btn-danger',
                name: 'Danger',
                section: 'btn'
            },

            {
                id: TREE_SELECTED_ITEM_GROUP_ID,
                name: 'Selected Item',
                section: TREE_SECTION_ID
            },
            {
                id: 'scrollbar-default',
                name: 'Use Scrollbar System Default',
                section: 'scrollbar'
            },

            {
                id: 'tscrollbar-track',
                name: 'Scrollbar Track',
                section: 'scrollbar'
            },

            {
                id: 'scrollbar-thumb',
                name: 'Scrollbar Thumb',
                section: 'scrollbar'
            }
        ]);

        appTheme.registerVars([
            {
                id: '#font-main',
                param: new FontField(glob, 'Font Face', [], null, {}),
                section: BASE_FONTS_AND_COLORS_SECTION_ID,
                group: 'base-font'
            },
            {
                id: 'font-main-size',
                param: new SelectField(glob, 'Font Size', [], 'default', {
                    values: [
                        'default',
                        'xx-small',
                        'x-small',
                        'small',
                        'medium',
                        'large',
                        'x-large',
                        'xx-large',
                        'smaller',
                        'larger'
                    ],
                    display: [
                        'default',
                        'xx-small',
                        'x-small',
                        'small',
                        'medium',
                        'large',
                        'x-large',
                        'xx-large',
                        'smaller',
                        'larger'
                    ]
                }),
                section: BASE_FONTS_AND_COLORS_SECTION_ID,
                group: 'base-font'
            },
            {
                id: 'font-main-weight',
                param: new SelectField(glob, 'Font Weight', [], 'normal', {
                    values: ['lighter', 'normal', 'bold', 'bolder'],
                    display: ['lighter', 'normal', 'bold', 'bolder']
                }),
                section: BASE_FONTS_AND_COLORS_SECTION_ID,
                group: 'base-font'
            },
            {
                id: 'font-main-italic',
                param: new BooleanField(glob, 'Italic', [], false),
                section: BASE_FONTS_AND_COLORS_SECTION_ID,
                group: 'base-font'
            },

            {
                id: 'base-has-shadow',
                param: new BooleanField(glob, 'Show Shadows', [], true),
                section: BASE_FONTS_AND_COLORS_SECTION_ID
            },

            {
                id: 'body-bg',
                param: new ColorBoxField(glob, 'Background', [], '#ffffff', {
                    hideTransparency: true,
                    title: 'Application Background Color'
                }),
                section: BASE_FONTS_AND_COLORS_SECTION_ID,
                group: 'base-background-colors'
            },

            {
                id: 'surface-bg',
                param: new ColorBoxField(glob, 'Surface', [], '#ffffff', {
                    hideTransparency: true
                }),
                section: BASE_FONTS_AND_COLORS_SECTION_ID,
                group: 'base-background-colors'
            },

            {
                id: 'primary-bg',
                param: new ColorBoxField(
                    glob,
                    'Primary Accent',
                    [],
                    '#757575', // gray-600
                    { hideTransparency: true }
                ),
                section: BASE_FONTS_AND_COLORS_SECTION_ID,
                group: 'base-background-colors'
            },

            {
                id: 'secondary-bg',
                param: new ColorBoxField(
                    glob,
                    'Secondary Accent',
                    [],
                    '#E0E0E0', // $gray-300,
                    { hideTransparency: true }
                ),
                section: BASE_FONTS_AND_COLORS_SECTION_ID,
                group: 'base-background-colors'
            },

            {
                id: 'gray-base',
                param: new ColorBoxField(
                    glob,
                    'On Surface',
                    [],
                    function (theme) {
                        return getContrastColor(theme, 'surface-bg');
                    },
                    { hideTransparency: true }
                ),
                section: BASE_FONTS_AND_COLORS_SECTION_ID,
                group: 'base-foreground-colors',
                deps: ['surface-bg']
            },

            {
                id: 'on-primary',
                param: new ColorBoxField(
                    glob,
                    'On Primary',
                    [],
                    function (theme) {
                        return getContrastColor(theme, 'primary-bg');
                    },
                    { hideTransparency: true }
                ),
                section: BASE_FONTS_AND_COLORS_SECTION_ID,
                group: 'base-foreground-colors',
                deps: ['primary-bg']
            },

            {
                id: 'on-secondary',
                param: new ColorBoxField(
                    glob,
                    'On Secondary',
                    [],
                    function (theme) {
                        return getContrastColor(theme, 'secondary-bg');
                    },
                    { hideTransparency: true }
                ),
                section: BASE_FONTS_AND_COLORS_SECTION_ID,
                group: 'base-foreground-colors',
                deps: ['secondary-bg']
            },

            {
                id: 'brand-success',
                param: new ColorBoxField(glob, 'Success', [], '#5cb85c', {
                    hideTransparency: true
                }),
                section: BASE_FONTS_AND_COLORS_SECTION_ID,
                group: 'brand-colors'
            },

            {
                id: 'brand-info',
                param: new ColorBoxField(glob, 'Info', [], '#5bc0de', {
                    hideTransparency: true
                }),
                section: BASE_FONTS_AND_COLORS_SECTION_ID,
                group: 'brand-colors'
            },

            {
                id: 'brand-danger',
                param: new ColorBoxField(glob, 'Danger', [], '#d9534f', {
                    hideTransparency: true
                }),
                section: BASE_FONTS_AND_COLORS_SECTION_ID,
                group: 'brand-colors'
            },

            {
                id: 'close-color',
                param: new ColorBoxField(
                    glob,
                    'Close Button',
                    [],
                    function (theme) {
                        return theme['gray-base'];
                    },
                    { hideTransparency: true }
                ),
                section: 'modal',
                deps: ['gray-base']
            },

            // NAVIAGATE BAR ----------------------------------------------------
            {
                id: 'navbar-background',
                param: new ColorBoxField(
                    glob,
                    'Navigation Bar Background',
                    [],
                    function (theme) {
                        return Color(theme['primary-bg']).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: NAVIGATION_BAR_SECTION_ID,
                deps: ['primary-bg']
            },
            {
                id: 'navbar-foreground',
                param: new ColorBoxField(
                    glob,
                    'Navigation Bar Foreground',
                    [],
                    function (theme) {
                        return Color(theme['on-primary']).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: NAVIGATION_BAR_SECTION_ID,
                deps: ['on-primary']
            },
            {
                id: 'navbar-material-style',
                param: new BooleanField(glob, 'Material style (Underlined active tabs)', [], false),
                section: 'navbar'
            },
            {
                id: 'navbar-active-link-hover-border-color',
                param: new ColorBoxField(
                    glob,
                    'Actibe Tab border',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.868).hexString();
                    },
                    { hideTransparency: false }
                ),
                section: NAVIGATION_BAR_SECTION_ID,
                deps: ['gray-base', 'surface-bg']
            },
            {
                id: 'navbar-active-bg',
                param: new ColorBoxField(
                    glob,
                    'Active Tab underine color (Material Style)',
                    [],
                    function (theme) {
                        return Color(theme['surface-bg']).hexString();
                    },
                    { hideTransparency: false }
                ),
                section: NAVIGATION_BAR_SECTION_ID,
                deps: ['surface-bg']
            },
            {
                id: 'navbar-has-shadow',
                param: new BooleanField(glob, 'Has Shadow', [], function (theme): boolean {
                    let bReturn: boolean = theme['base-has-shadow'];
                    return bReturn;
                }),
                section: NAVIGATION_BAR_SECTION_ID,
                deps: ['base-has-shadow']
            },
            {
                id: 'nav-tabs-active-tab-font-bold',
                param: new BooleanField(glob, 'Active Tab bold font', [], false),
                section: NAVIGATION_BAR_SECTION_ID
            },
            {
                id: 'nav-tabs-hover-border-color',
                param: new ColorBoxField(
                    glob,
                    'Navigation Bar Tab Highlighting Color',
                    [],
                    function (theme) {
                        return Color(theme['secondary-bg']).hexString();
                    },
                    { hideTransparency: false }
                ),
                section: NAVIGATION_BAR_SECTION_ID,
                deps: ['secondary-bg']
            },
            {
                id: themeVars.navigationBar_PinnedByDefault,
                param: new BooleanField(glob, 'Navigation Bar is pinned by default', [], true),
                section: NAVIGATION_BAR_SECTION_ID
            },
            // {
            //     id: 'nav-tabs-padding-top',
            //     param: new StringField(glob, 'Top Padding', [], '1rem', {
            //         applyOnEnter: true,
            //         allowNull: true
            //     }),
            //     section: 'navbar'
            // },

            // {
            //     id: 'navbar-active-tab-font',
            //     param: new FontBoxField(
            //         glob,
            //         'Font of Active Tab',
            //         [],
            //         function (theme) {
            //             return {
            //                 face: theme['#font-main'],
            //                 size: theme['font-main-size'],
            //                 weight: theme['font-main-weight'],
            //                 color: Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.4).hexString()
            //             };
            //         },
            //         { showColor: true }
            //     ),
            //     section: 'navbar'
            // },

            // end of NAVIAGETE BAR -----------------------------------------------

            {
                id: 'progress-bar-bg',
                param: new ColorBoxField(
                    glob,
                    'Progress Bar Color',
                    [],
                    function (theme) {
                        return Color(theme['primary-bg']).hexString();
                    },
                    { hideTransparency: false }
                ),
                section: 'progress-bar',
                deps: ['primary-bg']
            },

            {
                id: 'progress-bar-height',
                param: new NumberField(
                    glob,
                    'Progress Bar Height',
                    [validators.number.not_negative, validators.number.integer],
                    16,
                    {
                        min: 0,
                        applyOnEnter: true
                    }
                ),
                section: 'progress-bar'
            },

            {
                id: 'progress-bar-striped',
                param: new BooleanField(glob, 'Striped', [], true),
                section: 'progress-bar'
            },

            {
                id: 'progress-bar-animated',
                param: new BooleanField(glob, 'Animated', [], true),
                section: 'progress-bar'
            },

            {
                id: 'link-color',
                param: new ColorBoxField(
                    glob,
                    'Link Color',
                    [],
                    function (theme) {
                        return Color(theme['primary-bg']).hexString();
                    },
                    {
                        hideTransparency: true
                    }
                ),
                section: 'link',
                deps: ['primary-bg']
            },

            {
                id: 'link-hover-color',
                param: new ColorBoxField(
                    glob,
                    'Link Hover Color',
                    [],
                    function (theme) {
                        return Color(theme['link-color']).darken(15).hexString();
                    },
                    {
                        hideTransparency: true
                    }
                ),
                section: 'link',
                deps: ['link-color']
            },

            {
                id: 'link-underline',
                param: new BooleanField(glob, 'Underline', [], false),
                section: 'link',
                deps: []
            },

            {
                id: 'btn-has-border',
                param: new BooleanField(glob, 'Has Border', [], true),
                section: 'btn'
            },

            {
                id: 'btn-border-radius',
                param: new NumberField(
                    glob,
                    'Border Radius (0-24)',
                    [validators.number.range(0, 24), validators.number.integer],
                    3,
                    {
                        min: 0,
                        applyOnEnter: true
                    }
                ),
                section: 'btn'
            },

            {
                id: 'btn-has-shadow',
                param: new BooleanField(glob, 'Has Shadow', [], function (theme): boolean {
                    let bReturn: boolean = theme['base-has-shadow'];
                    return bReturn;
                }),
                section: 'btn',
                deps: ['base-has-shadow']
            },

            {
                id: 'btn-all-caps',
                param: new BooleanField(glob, 'ALL CAPS', [], false),
                section: 'btn'
            },

            {
                id: 'btn-default-color',
                param: new ColorBoxField(
                    glob,
                    'Button Text',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.2).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'btn',
                group: 'btn-default',
                deps: ['gray-base', 'surface-bg']
            },

            {
                id: 'btn-default-bg',
                param: new ColorBoxField(
                    glob,
                    'Button Background',
                    [],
                    function (theme) {
                        return theme['surface-bg'];
                    },
                    { hideTransparency: false }
                ),
                section: 'btn',
                group: 'btn-default',
                deps: ['surface-bg']
            },

            {
                id: 'btn-default-border',
                param: new ColorBoxField(
                    glob,
                    'Button Border',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.8).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'btn',
                group: 'btn-default',
                deps: ['gray-base', 'surface-bg']
            },

            {
                id: 'btn-success-color',
                param: new ColorBoxField(glob, 'Button Text', [], '#ffffff', {
                    hideTransparency: true
                }),
                section: 'btn',
                group: 'btn-success'
            },

            {
                id: 'btn-success-bg',
                param: new ColorBoxField(
                    glob,
                    'Button Background',
                    [],
                    function (theme) {
                        return theme['brand-success'];
                    },
                    { hideTransparency: false }
                ),
                section: 'btn',
                group: 'btn-success',
                deps: ['brand-success']
            },

            {
                id: 'btn-success-border',
                param: new ColorBoxField(
                    glob,
                    'Button Border',
                    [],
                    function (theme) {
                        return Color(theme['brand-success']).darken(5).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'btn',
                group: 'btn-success',
                deps: ['brand-success']
            },

            {
                id: 'btn-info-color',
                param: new ColorBoxField(glob, 'Button Text', [], '#ffffff', {
                    hideTransparency: true
                }),
                section: 'btn',
                group: 'btn-info'
            },

            {
                id: 'btn-info-bg',
                param: new ColorBoxField(
                    glob,
                    'Button Background',
                    [],
                    function (theme) {
                        return theme['brand-info'];
                    },
                    { hideTransparency: false }
                ),
                section: 'btn',
                group: 'btn-info',
                deps: ['brand-info']
            },

            {
                id: 'btn-info-border',
                param: new ColorBoxField(
                    glob,
                    'Button Border',
                    [],
                    function (theme) {
                        return Color(theme['brand-info']).darken(5).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'btn',
                group: 'btn-info',
                deps: ['brand-info']
            },

            {
                id: 'btn-danger-color',
                param: new ColorBoxField(glob, 'Button Text', [], '#ffffff', {
                    hideTransparency: true
                }),
                section: 'btn',
                group: 'btn-danger'
            },

            {
                id: 'btn-danger-bg',
                param: new ColorBoxField(
                    glob,
                    'Button Background',
                    [],
                    function (theme) {
                        return theme['brand-danger'];
                    },
                    { hideTransparency: false }
                ),
                section: 'btn',
                group: 'btn-danger',
                deps: ['brand-danger']
            },

            {
                id: 'btn-danger-border',
                param: new ColorBoxField(
                    glob,
                    'Button Border',
                    [],
                    function (theme) {
                        return Color(theme['brand-danger']).darken(5).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'btn',
                group: 'btn-danger',
                deps: ['brand-danger']
            },

            // ======================== DATE FIELD ==============================
            {
                id: 'input-date-field-bg',
                param: new ColorBoxField(
                    glob,
                    'Input Background Color',
                    [],
                    function (theme) {
                        return Color(theme['surface-bg']).hexString();
                    },
                    { hideTransparency: false }
                ),
                section: 'dateField',
                deps: ['surface-bg']
            },

            {
                id: 'input-date-field-border-color',
                param: new ColorBoxField(
                    glob,
                    'Input Border',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.7).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'dateField',
                deps: ['gray-base', 'surface-bg']
            },
            {
                id: 'input-date-field-icon-color',
                param: new ColorBoxField(
                    glob,
                    'Icon Color',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.2).hexString();
                    },
                    { hideTransparency: false }
                ),
                section: 'dateField',
                deps: ['gray-base', 'surface-bg']
            },
            {
                id: 'input-date-field-picker-bg',
                param: new ColorBoxField(
                    glob,
                    'Picker Background Color',
                    [],
                    function (theme) {
                        return Color(theme['surface-bg']).hexString();
                    },
                    { hideTransparency: false }
                ),
                section: 'dateField',
                deps: ['surface-bg']
            },            
            {
                id: 'input-date-field-picker-color',
                param: new ColorBoxField(
                    glob,
                    'Picker Color',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.2).hexString();
                    },
                    { hideTransparency: false }
                ),
                section: 'dateField',
                deps: ['gray-base', 'surface-bg']
            },

            {
                id: 'input-bg',
                param: new ColorBoxField(
                    glob,
                    'Input Background',
                    [],
                    function (theme) {
                        return theme['surface-bg'];
                    },
                    { hideTransparency: false }
                ),
                section: 'input',
                deps: ['surface-bg']
            },

            {
                id: 'input-color',
                param: new ColorBoxField(
                    glob,
                    'Input Foreground',
                    [],
                    function (theme) {
                        return theme['gray-base'];
                    },
                    { hideTransparency: true }
                ),
                section: 'input',
                deps: ['gray-base']
            },

            {
                id: 'input-border',
                param: new ColorBoxField(
                    glob,
                    'Input Border',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.8).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'input',
                deps: ['gray-base', 'surface-bg']
            },

            {
                id: 'input-focus-accent',
                param: new BooleanField(glob, 'Focus Accent', [], false),
                section: 'input'
            },

            {
                id: 'input-focus-accent-color',
                param: new ColorBoxField(
                    glob,
                    'Accent Color',
                    [],
                    function (theme) {
                        return Color(theme['secondary-bg']).darken(20).hexString();
                    },
                    {
                        hideTransparency: true
                    }
                ),
                section: 'input',
                deps: ['secondary-bg']
            },

            {
                id: 'dropdown-bg',
                param: new ColorBoxField(
                    glob,
                    'Dropdown Background',
                    [],
                    function (theme) {
                        return theme['surface-bg'];
                    },
                    { hideTransparency: true }
                ),
                section: CONTEXT_MENU_SECTION_ID,
                deps: ['surface-bg']
            },

            {
                id: 'dropdown-border',
                param: new ColorBoxField(
                    glob,
                    'Dropdown Border',
                    [],
                    function (theme) {
                        var color = Color(theme['gray-base']);
                        color.setValues('alpha', 0.15);
                        return color.rgbaString();
                    },
                    { hideTransparency: false }
                ),
                section: CONTEXT_MENU_SECTION_ID,
                deps: ['gray-base']
            },

            {
                id: 'dropdown-divider-bg',
                param: new ColorBoxField(
                    glob,
                    'Dropdown Divider',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.897).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: CONTEXT_MENU_SECTION_ID,
                deps: ['gray-base', 'surface-bg']
            },

            {
                id: 'dropdown-link-hover-bg',
                param: new ColorBoxField(
                    glob,
                    'Dropdown Link Hover Background',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.96).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: CONTEXT_MENU_SECTION_ID,
                deps: ['gray-base', 'surface-bg']
            },

            {
                id: 'nav-tabs-material-style',
                param: new BooleanField(glob, 'Material style (Underlined active tabs)', [], false),
                section: 'navtab'
            },

            {
                id: 'nav-tabs-and-pills-text-color',
                param: new ColorBoxField(
                    glob,
                    'Nav Tab and Pill Foreground',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.2).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'navtab',
                deps: ['gray-base', 'surface-bg']
            },

            {
                id: 'nav-tabs-border-color',
                param: new ColorBoxField(
                    glob,
                    'Nav Tab Border',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.868).hexString();
                    },
                    { hideTransparency: false }
                ),
                section: 'navtab',
                deps: ['gray-base', 'surface-bg']
            },

            {
                id: 'nav-tabs-active-bg',
                param: new ColorBoxField(
                    glob,
                    'Nav Tab Active Background',
                    [],
                    function (theme) {
                        return Color(theme['surface-bg']).hexString();
                    },
                    { hideTransparency: false }
                ),
                section: 'navtab',
                deps: ['surface-bg']
            },

            {
                id: 'nav-tabs-active-color',
                param: new ColorBoxField(
                    glob,
                    'Nav Tab Active Foreground',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'navtab',
                deps: ['gray-base']
            },

            {
                id: 'nav-tabs-active-link-hover-border-color',
                param: new ColorBoxField(
                    glob,
                    'Nav Tab Active Border',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.868).hexString();
                    },
                    { hideTransparency: false }
                ),
                section: 'navtab',
                deps: ['gray-base', 'surface-bg']
            },

            {
                id: 'nav-tabs-link-hover-border-color',
                param: new ColorBoxField(
                    glob,
                    'Nav Tab Hover Border',
                    [],
                    function (theme) {
                        return Color(theme['secondary-bg']).hexString();
                    },
                    { hideTransparency: false }
                ),
                section: 'navtab',
                deps: ['secondary-bg']
            },

            {
                id: 'nav-pills-active-link-hover-color',
                param: new ColorBoxField(
                    glob,
                    'Nav Pills Active Foreground',
                    [],
                    function (theme) {
                        return Color(theme['on-secondary']).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'navtab',
                deps: ['on-secondary']
            },

            {
                id: 'nav-pills-active-link-hover-bg',
                param: new ColorBoxField(
                    glob,
                    'Nav Pills Active Background',
                    [],
                    function (theme) {
                        return Color(theme['secondary-bg']).hexString();
                    },
                    { hideTransparency: false }
                ),
                section: 'navtab',
                deps: ['secondary-bg']
            },

            {
                id: 'nav-pills-border-radius',
                param: new NumberField(
                    glob,
                    'Nav Pills Border Radius (px)',
                    [validators.number.integer, validators.number.range(0, 50), validators.number.positive],
                    5
                ),
                section: 'navtab',
                deps: ['secondary-bg']
            },

            {
                id: 'popover-bg',
                param: new ColorBoxField(
                    glob,
                    'Popover Background',
                    [],
                    function (theme) {
                        return theme['surface-bg'];
                    },
                    { hideTransparency: true }
                ),
                section: 'popover',
                deps: ['surface-bg']
            },

            {
                id: 'popover-header-bg',
                param: new ColorBoxField(
                    glob,
                    'Popover Header Background',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.897).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'popover',
                deps: ['gray-base', 'surface-bg']
            },

            {
                id: 'popover-border-color',
                param: new ColorBoxField(
                    glob,
                    'Popover Border',
                    [],
                    function (theme) {
                        var color = Color(theme['gray-base']);
                        color.setValues('alpha', 0.2);
                        return color.rgbaString();
                    },
                    { hideTransparency: false }
                ),
                section: 'popover',
                deps: ['gray-base']
            },

            {
                id: 'modal-content-bg',
                param: new ColorBoxField(
                    glob,
                    'Modal Background',
                    [],
                    function (theme) {
                        return theme['surface-bg'];
                    },
                    { hideTransparency: true }
                ),
                section: 'modal',
                deps: ['surface-bg']
            },

            {
                id: 'modal-content-border-color',
                param: new ColorBoxField(
                    glob,
                    'Modal Content Border',
                    [],
                    function (theme) {
                        var color = Color(theme['gray-base']);
                        color.setValues('alpha', 0.2);
                        return color.rgbaString();
                    },
                    { hideTransparency: false }
                ),
                section: 'modal',
                deps: ['gray-base']
            },

            {
                id: 'modal-backdrop-bg',
                param: new ColorBoxField(
                    glob,
                    'Modal Backdrop Background',
                    [],
                    function (theme) {
                        return theme['gray-base'];
                    },
                    { hideTransparency: true }
                ),
                section: 'modal',
                deps: ['gray-base']
            },

            {
                id: 'modal-header-border-color',
                param: new ColorBoxField(
                    glob,
                    'Modal Header Border',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.897).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'modal',
                deps: ['gray-base', 'surface-bg']
            },

            // {
            //     id: 'list-group-bg',
            //     param: new ColorBoxField(
            //         glob,
            //         'List Group Background',
            //         [],
            //         function (theme) {
            //             return theme['surface-bg'];
            //         },
            //         { hideTransparency: true }
            //     ),
            //     section: 'listgroup',
            //     deps: ['surface-bg']
            // },

            // {
            //     id: 'list-group-border',
            //     param: new ColorBoxField(
            //         glob,
            //         'List Group Border',
            //         [],
            //         function (theme) {
            //             return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.868).hexString();
            //         },
            //         { hideTransparency: true }
            //     ),
            //     section: 'listgroup',
            //     deps: ['gray-base', 'surface-bg']
            // },

            // {
            //     id: 'list-group-hover-bg',
            //     param: new ColorBoxField(
            //         glob,
            //         'List Group Hover Background',
            //         [],
            //         function (theme) {
            //             return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.96).hexString();
            //         },
            //         { hideTransparency: true }
            //     ),
            //     section: 'listgroup',
            //     deps: ['gray-base', 'surface-bg']
            // },

            // {
            //     id: 'list-group-link-color',
            //     param: new ColorBoxField(
            //         glob,
            //         'List Group Link Text',
            //         [],
            //         function (theme) {
            //             return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.335).hexString();
            //         },
            //         { hideTransparency: true }
            //     ),
            //     section: 'listgroup',
            //     deps: ['gray-base', 'surface-bg']
            // },

            {
                id: 'panel-bg',
                param: new ColorBoxField(
                    glob,
                    'Panel Background',
                    [],
                    function (theme) {
                        return theme['surface-bg'];
                    },
                    { hideTransparency: true }
                ),
                section: 'panel',
                deps: ['surface-bg']
            },

            {
                id: 'panel-inner-border',
                param: new ColorBoxField(
                    glob,
                    'Panel Inner Border',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.868).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'panel',
                deps: ['gray-base', 'surface-bg']
            },

            {
                id: 'panel-footer-bg',
                param: new ColorBoxField(
                    glob,
                    'Panel Footer Background',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.96).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'panel',
                deps: ['gray-base', 'surface-bg']
            },

            {
                id: 'panel-border-color',
                param: new ColorBoxField(
                    glob,
                    'Panel Border',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.868).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'panel',
                deps: ['gray-base', 'surface-bg']
            },

            {
                id: 'panel-header-bg',
                param: new ColorBoxField(
                    glob,
                    'Panel Heading Background',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.96).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'panel',
                deps: ['gray-base', 'surface-bg']
            },

            {
                id: 'breadcrumb-bg',
                param: new ColorBoxField(
                    glob,
                    'Breadcrumb Background',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.96).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'breadcrumb',
                deps: ['gray-base', 'surface-bg']
            },

            {
                id: 'breadcrumb-color',
                param: new ColorBoxField(
                    glob,
                    'Breadcrumb Foreground',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.8).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'breadcrumb',
                deps: ['gray-base', 'surface-bg']
            },

            {
                id: 'notifications-success-color',
                param: new ColorBoxField(
                    glob,
                    'Success',
                    [],
                    function (theme) {
                        return Color(theme['brand-success']).mix(Color(theme['surface-bg']), 0.6).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'notifications',
                deps: ['brand-success', 'surface-bg']
            },

            {
                id: 'notifications-success-text-color',
                param: new ColorBoxField(
                    glob,
                    'Success Text',
                    [],
                    function (theme) {
                        return getContrastColor(theme, 'notifications-success-color');
                    },
                    { hideTransparency: true }
                ),
                section: 'notifications',
                deps: ['notifications-success-color']
            },

            {
                id: 'notifications-error-color',
                param: new ColorBoxField(
                    glob,
                    'Error',
                    [],
                    function (theme) {
                        return Color(theme['brand-danger']).mix(Color(theme['surface-bg']), 0.6).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'notifications',
                deps: ['brand-danger', 'surface-bg']
            },

            {
                id: 'notifications-error-text-color',
                param: new ColorBoxField(
                    glob,
                    'Error Text',
                    [],
                    function (theme) {
                        return getContrastColor(theme, 'notifications-error-color');
                    },
                    { hideTransparency: true }
                ),
                section: 'notifications',
                deps: ['notifications-error-color']
            },

            {
                id: 'notifications-warning-color',
                param: new ColorBoxField(
                    glob,
                    'Warning',
                    [],
                    function (theme) {
                        return Color(theme['brand-info']).mix(Color(theme['surface-bg']), 0.6).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'notifications',
                deps: ['brand-info', 'surface-bg']
            },

            {
                id: 'notifications-warning-text-color',
                param: new ColorBoxField(
                    glob,
                    'Warning Text',
                    [],
                    function (theme) {
                        return getContrastColor(theme, 'notifications-warning-color');
                    },
                    { hideTransparency: true }
                ),
                section: 'notifications',
                deps: ['notifications-worning-color']
            },

            {
                id: 'notifications-border-color',
                param: new ColorBoxField(
                    glob,
                    'Border',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.8).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: 'notifications',
                deps: ['gray-base', 'surface-bg']
            },

            {
                id: 'tree-font-size',
                param: new SelectField(glob, 'Font Size', [], 'inherit', {
                    values: [
                        'medium',
                        'xx-small',
                        'x-small',
                        'small',
                        'large',
                        'x-large',
                        'xx-large',
                        'smaller',
                        'larger',
                        'inherit'
                    ],
                    display: [
                        'medium',
                        'xx-small',
                        'x-small',
                        'small',
                        'large',
                        'x-large',
                        'xx-large',
                        'smaller',
                        'larger',
                        'default'
                    ]
                }),
                section: TREE_SECTION_ID
            },
            {
                id: 'tree-selected-bold-font',
                param: new BooleanField(glob, 'Bold', [], true),
                section: TREE_SECTION_ID,
                group: TREE_SELECTED_ITEM_GROUP_ID
            },
            {
                id: 'tree-selected-italic-font',
                param: new BooleanField(glob, 'Italic', [], false),
                section: TREE_SECTION_ID,
                group: TREE_SELECTED_ITEM_GROUP_ID
            },

            {
                id: 'scrollbar_default',
                param: new BooleanField(glob, 'Use Scrollbar System Default', [], true),
                section: 'scrollbar'
            },

            {
                id: 'scrollbar_track',
                param: new ColorBoxField(
                    glob,
                    'Scrollbar Track Color',
                    [],
                    function (theme) {
                        var isDark = Utilities.isDark(theme['surface-bg']);
                        if (isDark) {
                            return Color(theme['surface-bg']).lighten(30).hexString();
                        } else {
                            return Color(theme['surface-bg']).darken(10).hexString();
                        }
                    },
                    { hideTransparency: true }
                ),
                section: 'scrollbar',
                deps: ['surface-bg']
            },

            {
                id: 'scrollbar_thumb',
                param: new ColorBoxField(
                    glob,
                    'Scrollbar Thumb Color',
                    [],
                    function (theme) {
                        const isDark = Utilities.isDark(theme['surface-bg']);

                        if (isDark) {
                            return Color(theme['surface-bg']).lighten(20).hexString();
                        } else {
                            return Color(theme['surface-bg']).darken(20).hexString();
                        }
                    },
                    { hideTransparency: true }
                ),
                section: 'scrollbar',
                deps: ['surface-bg']
            },

            {
                id: 'colorbox-editing-border',
                param: new ColorBoxField(
                    glob,
                    'Border Color for Selected Color Box element',
                    [],
                    //function (theme) {
                    //    var isDark = Utilities.isDark(theme['surface-bg']);
                    //    if (isDark) {
                    //        return Color(theme['surface-bg']).lighten(20).hexString();
                    //    }
                    //    else {
                    //        return Color(theme['surface-bg']).darken(20).hexString();
                    //    }
                    //},
                    '#01579b',
                    { hideTransparency: true }
                ),
                section: 'colorbox'
            },
            
            {
                id: themeVars.itemSelector_SelectedItemBackgroundColor,
                param: new ColorBoxField(
                    glob,
                    'Selected Item Background Color',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.8).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: ITEM_SELECTOR_SECTION_ID,
                deps: ['gray-base', 'surface-bg']
            },
            {
                id: themeVars.itemSelector_SelectedItemForegroundColor,
                param: new ColorBoxField(
                    glob,
                    'Selected Item Foreground Color',
                    [],
                    function (theme) {
                        return getContrastColor(theme, 'surface-bg');
                    },
                    { hideTransparency: true }
                ),
                section: ITEM_SELECTOR_SECTION_ID,
                deps: ['surface-bg']
            },
            {
                id: themeVars.itemSelector_SelectedHiddenItemBackgroundColor,
                param: new ColorBoxField(
                    glob,
                    'Hidden Items Button Background Color',
                    [],
                    function (theme) {
                        return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.8).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: ITEM_SELECTOR_SECTION_ID,
                deps: ['gray-base', 'surface-bg']
            },
            {
                id: themeVars.itemSelector_ItemListBackgroundColor,
                param: new ColorBoxField(
                    glob,
                    'Item List Background Color',
                    [],
                    function (theme) {
                        return Color(theme['body-bg']).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: ITEM_SELECTOR_SECTION_ID,
                deps: ['body-bg']
            },
            {
                id: themeVars.itemSelector_ValidItemBackgroundColor,
                param: new ColorBoxField(glob, 'Valid Item Background Color', [], null, { hideTransparency: true }),
                section: ITEM_SELECTOR_SECTION_ID,
                deps: ['body-bg']
            },
            {
                id: themeVars.itemSelector_InvalidItemBackgroundColor,
                param: new ColorBoxField(
                    glob,
                    'Invalid Item Background Color',
                    [],
                    function (theme) {
                        return Color(theme['secondary-bg']).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: ITEM_SELECTOR_SECTION_ID,
                deps: ['secondary-bg']
            },
            {
                id: themeVars.itemSelector_SearchHighlightingColor,
                param: new ColorBoxField(
                    glob,
                    'Search Highlighting Color',
                    [],
                    function (theme) {
                        return Color(theme['btn-info-bg']).hexString();
                    },
                    { hideTransparency: true }
                ),
                section: ITEM_SELECTOR_SECTION_ID,
                deps: ['btn-info-bg']
            },
            {
                id: themeVars.itemSelector_SearchFromStartOnly,
                param: new BooleanField(glob, 'Search From Start Only', [], false),
                section: ITEM_SELECTOR_SECTION_ID,
                deps: ['btn-info-bg']
            }
        ]);

        appTheme.registerPreRender(function (input) {
            const vars = {};

            input['component-active-color'] = input['surface-bg'];
            //input['legend-border-color'] = '#e5e5e5';
            input['state-success-text'] = '#3c763d';
            input['state-success-bg'] = '#dff0d8';
            input['state-info-text'] = '#31708f';
            input['state-info-bg'] = '#d9edf7';
            //input['state-warning-bg'] = '#fcf8e3';
            input['state-danger-text'] = '#a94442';
            input['state-danger-bg'] = '#f2dede';

            vars['nav-tabs-justified-link-border-color'] = input['nav-tabs-active-link-hover-border-color'];
            vars['label-color'] = input['surface-bg'];
            vars['label-link-hover-color'] = input['surface-bg'];

            vars['progress-bg'] = Color(input['gray-base']).mix(Color(input['surface-bg']), 0.935).hexString();
            vars['progress-bar-color'] = input['on-primary'];
            //vars['progress-bar-bg'] = input['primary-bg'];    //VR fix: WorkItem [96243]: Setting of Color for Progress bar do not work

            vars['thumbnail-border'] = Color(input['gray-base']).mix(Color(input['surface-bg']), 0.865).hexString();
            //vars['badge-color'] = input['surface-bg'];
            //vars['badge-link-hover-color'] = input['surface-bg'];
            //vars['badge-active-bg'] = input['surface-bg'];

            vars['gray-darker'] = Color(input['gray-base']).mix(Color(input['surface-bg']), 0.135).hexString();
            vars['gray-dark'] = Color(input['gray-base']).mix(Color(input['surface-bg']), 0.2).hexString();
            vars['gray'] = Color(input['gray-base']).mix(Color(input['surface-bg']), 0.335).hexString();
            vars['gray-light'] = Color(input['gray-base']).mix(Color(input['surface-bg']), 0.467).hexString();
            vars['gray-lighter'] = Color(input['gray-base']).mix(Color(input['surface-bg']), 0.935).hexString();

            vars['text-color'] = vars['gray-dark'];

            //vars['link-color'] = input['primary-bg'];
            //vars['link-hover-color'] = Color(vars['link-color']).darken(15).hexString();

            vars['headings-color'] = 'inherit';

            vars['component-active-bg'] = input['brand-primary'];

            vars['btn-link-disabled-color'] = vars['gray-light'];

            vars['input-bg-disabled'] = vars['gray-lighter'];
            //vars['input-color'] = vars['gray'];
            //vars['legend-color'] = vars['gray-dark'];
            // vars['input-group-addon-bg'] = vars['gray-lighter'];
            // vars['input-group-addon-border-color'] = input['input-border'];

            vars['dropdown-link-color'] = vars['gray-dark'];
            vars['dropdown-link-hover-color'] = Color(vars['gray-dark']).darken(5).hexString();
            vars['dropdown-link-active-color'] = input['component-active-color'];
            vars['dropdown-link-active-bg'] = vars['component-active-bg'];
            vars['dropdown-link-disabled-color'] = vars['gray-light'];
            vars['dropdown-header-color'] = vars['gray-light'];

            vars['nav-link-hover-bg'] = vars['gray-lighter'];

            vars['nav-disabled-link-color'] = vars['gray-light'];
            vars['nav-disabled-link-hover-color'] = vars['gray-light'];

            //vars['nav-tabs-link-hover-border-color'] = vars['gray-lighter'];

            vars['nav-tabs-active-link-hover-bg'] = input['surface-bg'];
            vars['nav-tabs-active-link-hover-color'] = vars['gray-base'];

            //vars['nav-pills-active-link-hover-bg'] = vars['component-active-bg'];
            //vars['nav-pills-active-link-hover-color'] = input['component-active-color'];

            vars['state-success-border'] = Color(input['state-success-bg']).rotate(-10).darken(5).hexString();
            vars['state-info-border'] = Color(input['state-info-bg']).rotate(-10).darken(5).hexString();
            vars['state-danger-border'] = Color(input['state-danger-bg']).rotate(-10).darken(5).hexString();

            vars['popover-title-bg'] = Color(input['popover-bg']).darken(3).hexString();
            vars['popover-arrow-color'] = input['popover-bg'];
            vars['popover-arrow-outer-color'] = Color(input['popover-border-color']).opaquer(0.25).rgbaString();

            vars['label-default-bg'] = vars['gray-light'];
            vars['label-success-bg'] = input['brand-success'];
            vars['label-info-bg'] = input['brand-info'];
            vars['label-danger-bg'] = input['brand-danger'];

            vars['modal-footer-border-color'] = input['modal-header-border-color'];

            vars['list-group-active-color'] = input['component-active-color'];
            vars['list-group-active-bg'] = vars['component-active-bg'];
            vars['list-group-active-border'] = vars['list-group-active-bg'];
            vars['list-group-active-text-color'] = Color(vars['list-group-active-bg']).lighten(40).hexString();

            vars['list-group-disabled-color'] = vars['gray-light'];
            vars['list-group-disabled-bg'] = vars['gray-lighter'];
            vars['list-group-disabled-text-color'] = vars['list-group-disabled-color'];

            vars['list-group-link-hover-color'] = input['list-group-link-color'];

            vars['panel-default-text'] = vars['gray-dark'];

            vars['panel-success-text'] = input['state-success-text'];
            vars['panel-success-border'] = input['state-success-border'];
            vars['panel-success-heading-bg'] = input['state-success-bg'];

            vars['panel-info-text'] = input['state-info-text'];
            vars['panel-info-border'] = input['state-info-border'];
            vars['panel-info-heading-bg'] = input['state-info-bg'];

            vars['panel-danger-text'] = input['state-danger-text'];
            vars['panel-danger-border'] = input['state-danger-border'];
            vars['panel-danger-heading-bg'] = input['state-danger-bg'];

            vars['thumbnail-bg'] = input['surface-bg'];

            //vars['badge-bg'] = vars['gray-light'];
            //vars['badge-active-color'] = vars['link-color'];

            vars['breadcrumb-active-color'] = vars['gray-light'];

            vars['text-muted'] = vars['gray-light'];
            //vars['abbr-border-color'] = vars['gray-light'];
            vars['headings-small-color'] = vars['gray-light'];
            // vars['blockquote-small-color'] = vars['gray-light'];
            // vars['blockquote-border-color'] = vars['gray-lighter'];
            //vars['page-header-border-color'] = vars['gray-lighter'];
            vars['hr-border'] = vars['gray-lighter'];

            input['scrollbar_hover'] = Color(input['scrollbar_thumb']).darken(10).hexString();
            return _.extend(input, vars);
        });

        appTheme.registerTemplate(template, ['application', 'workspace', 'widget']);

        _init.push(glob);
    }
}
